import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';

import ChevronLeftIcon from '@lt/components/icons-react/rebrand/ChevronLeft';

import styles from './mobilePage.module.css';

const MobileBackButton = (props) => {
  const { t } = useTranslation();
  return (
    <Button className={styles.button} functional {...props}>
      <ChevronLeftIcon height={16} />
      {t('hotel.cigarette.mobile.backButton')}
    </Button>
  );
};

MobileBackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default MobileBackButton;
